import "../css"

$(document).on("click", "table.photographers", function() {
  location = "/pages/staff"
})

$(function () {
  $('[data-toggle="tooltip"]').tooltip()
})
